export const approvedFields = [
    { field: 'eApprovedBy', status: 'eApprovedStatus', date: 'createdDateTime' },
    { field: 'eApprovedByITLead', status: 'eApprovedByITLeadStatus', date: 'eApprovedDate' },
    { field: 'eApprovedByITHead', status: 'eApprovedByITHeadStatus', date: 'eApprovedByITLeadDate' },
    { field: 'eAssignee', status: 'eAssigneeStatus', date: 'eApprovedByITHeadDate' }
];